export const Rooms = [
    ['Start', '1'],
    ['Shop', '2'],
    ['Error', '3'],
    ['Treasure', '4'],
    ['Boss', '5'],
    ['Miniboss', '6'],
    ['Secret', '7'],
    ['Supersecret', '8'],
    ['Arcade', '9'],
    ['Curse', '10'],
    ['Challenge', '11'],
    ['Library', '12'],
    ['Sacrifice', '13'],
    ['Devil', '14'],
    ['Angel', '15'],
    ['Dungeon', '16'],
    ['Bossrush', '17'],
    ['Isaacs', '18'],
    ['Barren', '19'],
    ['Chest', '20'],
    ['Dice', '21'],
    ['Black Market', '22'],
    ['Greed Exit', '23'],
    ['Planetarium', '24'],
    ['Teleporter', '25'],
    ['Teleporter Exit', '26'],
    ['Ultrasecret', '29'],
  ];
  